export enum EAPRType {
    AdductionAirALaDemande = 1,
    AdductionAirDebitContinu = 2,
    TM3P = 3,
    DemiMasqueP3 = 4,
    FFP3 = 5,
    Aucun = 6,
    TenueEtancheVentilee = 7,
    FFP1 = 8,
    P3Complet = 9,
}